"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Divider_1 = __importDefault(require("@material-ui/core/Divider"));
var classnames_1 = __importDefault(require("classnames"));
var useStyles_1 = __importDefault(require("./useStyles"));
var Divider = function (_a) {
    var _b;
    var _c = _a.classes, classes = _c === void 0 ? {} : _c, _d = _a.absolute, absolute = _d === void 0 ? false : _d, _e = _a.flexItem, flexItem = _e === void 0 ? false : _e, _f = _a.light, light = _f === void 0 ? false : _f, _g = _a.orientation, orientation = _g === void 0 ? 'horizontal' : _g, _h = _a.variant, variant = _h === void 0 ? 'fullWidth' : _h, _j = _a.component, component = _j === void 0 ? 'hr' : _j, margin = _a.margin;
    var innerStyles = (0, useStyles_1.default)({ margin: margin });
    return (react_1.default.createElement(Divider_1.default, { classes: __assign(__assign({}, classes), { root: (0, classnames_1.default)((_b = {},
                _b[innerStyles.root] = true,
                _b[classes.root || ''] = true,
                _b)) }), absolute: absolute, flexItem: flexItem, light: light, orientation: orientation, variant: variant, component: component }));
};
exports.default = Divider;
